import { Pair } from '../services/token/get-supported-pairs';

export enum OrderSide {
  Buy = 1,
  Sell = 2,
}

export enum OrderType {
  Limit = 1,
  Market = 2,
}

export enum MarketOrderBy {
  Amount = 0,
  Total = 1,
}

export enum ORDER_STATUS {
  Invalid = -2,
  Pending = 0, // Pending order waiting for lock balance
  Canceled = -1, // Cancel order
  Fillable = 1, // Order waiting for exchange
  Filling = 2, // Order in exchange processing with another order
  Fulfill = 3, // Order is done
  PartiallyFilled = 4,
}

export const BOOLEAN = {
  TRUE: 1,
  FALSE: 0,
};

export const DECIMAL_COIN = {
  STABLE: 4,
  FNFT: 3,
};

export const PAGE_LIMIT = 10;

export const MAX_ITEM_ORDER_HISTORY = 10;

export const IS_STABLE_COIN = 0;

export enum TradingMethod {
  StellarOrderbook = 1,
  BSCOrderbook = 2,
  BSCPool = 4,
  PancakeswapPool = 8,
  CombinedOrderbook = TradingMethod.StellarOrderbook | TradingMethod.BSCOrderbook,
  All = TradingMethod.StellarOrderbook | TradingMethod.BSCOrderbook | TradingMethod.BSCPool,
}

export const OTHER_TOKEN_MINIMUM_WITHDRAWAL = 0.005;

//TODO: Retrieve data from oracle
export const MINIMUM_WITHDRAWAL = new Map<string, number>([
  ['USDT', 10],
  ['USDC', 10],
  ['WBTC', 0.00012],
  ['WETH', 0.004],
]);

export const ERRORS = {
  UNKNOWN_ERROR: {
    message: 'internal server error',
    code: -1,
  },
  USER_NOT_EXIST: {
    message: 'user not exist',
    code: 1,
  },
  INVALID_SIGNATURE: {
    message: 'Invalid signature',
    code: 2,
  },
  USER_EXISTED: {
    message: 'user existed',
    code: 3,
  },
  UNAUTHORIZED: {
    message: 'unauthorized',
    code: 4,
  },
  FORBIDDEN: {
    message: 'forbidden',
    code: 5,
  },
  TOO_MANY_REQUESTS: {
    message: 'too many requests',
    code: 6,
  },
  REFRESH_TOKEN_FAIL: {
    message: 'refresh token fail',
    code: 7,
  },
  REFRESH_TOKEN_EXPIRED: {
    message: 'refresh token expired',
    code: 8,
  },
  REFERRAL_CODE_ALREADY_EXISTS: {
    message: 'Referral code already exists',
    code: 9,
  },
  REFERRAL_CODE_ALREADY_USE: {
    message: 'Referral code already use',
    code: 10,
  },
  USE_REFERRAL_CODE: {
    message: 'Referral code not provided',
    code: 11,
  },
  INVALID_OR_ALREADY_USED_REFERRAL_CODE: {
    message: 'Invalid or already used referral code',
    code: 12,
  },
  INSUFFICIENT_AIRDROP_BALANCE: {
    message: 'Insufficient airdrop balance',
    code: 13,
  },
};

export const mobileMenuBreakPoint = 1024;
export const SmallDesktopBreakPoint = 1300;

export const localstorageKeys = {
  leverage: (pair: Pair) => 'leverage-' + pair.id,
};
